import {Pageable, Response, Measure, PageRequest} from "@core/model";
import {ApiBuilder} from "..";
import {Multivalue} from "@core/model/Measure";

export type SearchMeasuresRequest = PageRequest & {
  from?: number;
  to?: number;
  name: string;
  // filtri sui valori delle colonne (sensori multivalore)
  filters?: MeasureValueFilter[];
};

export type MeasureValueFilter = {
  index: number;
  value: string;
};

const searchMeasures = (builder: ApiBuilder) =>
  builder.query<Pageable<Measure<number | Multivalue>>, SearchMeasuresRequest>({
    query: ({from, to, name, page, size, sort, filters}) => {
      const params = new URLSearchParams();
      if (from) params.append("from", from.toString());
      if (to) params.append("to", to.toString());
      params.append("page", page.toString());
      params.append("size", size.toString());
      params.append("sort", sort);
      // formato: filter=<index>:<valore>, un parametro per filtro
      filters?.forEach(f => params.append("filter", `${f.index}:${f.value}`));

      return {
        url: `/api/measure/search/${name}?${params.toString()}`,
        method: "GET",
      };
    },
    transformResponse: (
      response: Response<Pageable<Measure<number | Multivalue>>>,
    ) => response.data,
    providesTags: (result, _err, params) => {
      return result
        ? [
            {
              type: "measure",
              id: `${params.from ?? ""}-${params.to ?? ""}-${params.name}-${params.page}-${params.size}-${params.filters?.map(f => `${f.index}:${f.value}`).join("|") ?? ""}`,
            },
          ]
        : [];
    },
  });

export {searchMeasures};
